import {httpRequest} from "../../../utils/HttpRequest";
import {ICatalogParams,ICatalogSearch,ICatalogDetail,FieldSearch} from "./dataCatalogTypes"
import {IPage,IPageRet, ISearchPage} from "../../../types/FmsTypes";

export interface ICatalogDetails {
    code: string,
    tableName: string,
    note: string,
    allowRemoteSelect: number,
    allowRemoteInsert: number,
    allowRemoteUpdate: number,
    allowRemoteDelete: number,
    allowMultiBranch: number,
    defaultBranchCode: string,
    status: number,
    key: string
} 
export interface FieldDetails {
    code?: string,
    nullable?: number,
    catalog?: string,
    repeatable?: number,
    dataType?: string,
    updatable?: number,
    maxLength?: number,
    key?: string,
    status?: number

}
class CatalogService {
    async page(params:ICatalogSearch){
        const apiUrl = "/mdm/catalog/page";
        return await httpRequest.post<IPage<ICatalogDetails>>(apiUrl, params);
    }
    async insert(params:ICatalogDetail){
        const apiUrl = "/mdm/catalog/insert";
        return await httpRequest.post<IPage<boolean>>(apiUrl, params);
    }
    async update(params:ICatalogDetail){
        const apiUrl = "/md/mdm/catalog/update";
        return await httpRequest.post<IPage<boolean>>(apiUrl, params);
    }
    
}
class FieldService {
    async onePage(params:FieldSearch){
        const apiUrl = "/mdm/field/page";
        return await httpRequest.post<IPage<FieldDetails>>(apiUrl, params);
    }    
    async insert(params:FieldDetails){
        const apiUrl = "/mdm/field/insert";
        return await httpRequest.post<IPage<boolean>>(apiUrl, params);
    }
    async update(params:ICatalogDetail){
        const apiUrl = "/mdm/field/update";
        return await httpRequest.post<IPage<boolean>>(apiUrl, params);
    }
    async remove(catalog:string,code:string){
        const apiUrl = `/mdm/field/remove/${catalog}/${code}`;
        return await httpRequest.get<IPage<boolean>>(apiUrl);
    }
}
 const catalogService = new CatalogService();
 const fieldService = new FieldService();
export {
    catalogService,
    fieldService
}